import { func, string, shape, bool } from 'prop-types';
import Input from '../../shared/Input';
import { Stack, FormStack } from '../../shared/layouts';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const ContactSection = ({
  handleChange,
  phone_number,
  email,
  errors,
  partner,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { MessageIcon } = useIconLibrary();

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t('Contactgegevens') + (partner ? ' ' + t('partner') : '')}
          icon={<MessageIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          {/* Row */}
          <Input
            type="tel"
            label={t("Telefoonnummer")}
            name="phone_number"
            value={phone_number || ''}
            onChange={handleChange}
            errors={errors.phone_number}
            readOnly={readOnly}
          />
          <Input
            name="email"
            label={t("E-mailadres")}
            value={email}
            onChange={handleChange}
            errors={errors.email}
            readOnly={readOnly}
          />
        </FormStack>
      </Stack>
    </Card>
  );
}

ContactSection.propTypes = {
  handleChange: func,
  phone_number: string,
  email: string,
  partner: bool,
  errors: shape({}),
};

ContactSection.defaultProps = {
  phone_number: '',
  email: '',
  partner: false,
  errors: {},
};
export default ContactSection;
